export const mapColors = {
    available: "#669EDA",
    availableHover: "#20B1EA",
    notAvailable: "#1E1F43",
    textColor: "#505173",
    textHoverColor: "#fff",
    background: "#000"
};